<template>
  <div class="row">
    <side-menu :title="'交通費未精算一覧'"></side-menu>
    <div class="col-md-10 pt-3">
      <div v-if="kotsuhiList.length == 0">未精算はありません</div>
      <div v-else>
          未精算: {{kotsuhiList.length}}件
          <div>
          <button type="button" class="btn btn-info btn-sm m-2" @click="goToHitory">交通費履歴へ</button>
          </div>
          <table class="table table-bordered table-responsive">
              <thead class="thead-light">
              <tr>
                  <th>No</th>
                  <th>氏名</th>
                  <th>対象日</th>
                  <th>出発駅</th>
                  <th>到着駅</th>
                  <th>使用路線</th>
                  <th>料金種類</th>
                  <th>利用用途</th>
                  <th>費用</th>
                  <th>ステータス</th>
                  <th>申請日</th>
              </tr>
              </thead>
              <tbody>
                  <tr v-for="(result, index) in kotsuhiList" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{result.userName}}</td>
                      <td>{{result.targetDate}}</td>
                      <td>{{result.startStation}}</td>
                      <td>{{result.endStation}}</td>
                      <td>{{result.route}}</td>
                      <td>{{result.type}}</td>
                      <td>{{result.useType}}</td>
                      <td>{{result.expense}}</td>
                      <td>{{result.status}}</td>
                      <td>{{result.createdDate}}</td>
                  </tr>
              </tbody>
          </table>
      </div>
    </div>
  </div>
</template>

<style scoped>
.noflap{
 white-space: nowrap;
}
</style>

<script>
import SideMenu from "../SideMenu.vue";
import KotsuhiAPI from '../../../api/kotsuhi-api'

export default {
  name: "kotsuhi-unpaid-list",
  components: {
    SideMenu,
  },
  data() {
    return {
      loginUser: {},
      kotsuhiList: [],
    }
  },
  watch: {
    '$root.$refs.asnHeader.$data.loginUser': function (val) {
      this.loginUser = val
      this.getKotsuhiList()
    },
  },
  mounted () {
  },
  methods: {
    // 交通費一覧取得
    getKotsuhiList () {
      this.$root.$refs.loading.$data.show = true
      KotsuhiAPI.getUnpaidKotsuhiList(this.loginUser.userId)
        .then(res => {
            this.kotsuhiList = res
            this.$root.$refs.loading.$data.show = false
        })
        .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
        })
    },
    goToHitory() {
        this.$router.push('/operator/kotsuhi/history')
    }
  },
  filters: {
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/operator/kotsuhi/KotsuhiUnpaidList.vue